import {
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "components/Header/Header";
import SongScoringList from "components/lists/SongScoringList/SongScoringList";
import PageArrows from "components/PageArrows/PageArrows";
import RatingButtonsGuide from "components/RatingButtonsGuide/RatingButtonsGuide";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";
import MainContainer from "components/styled/MainContainer";
import React, { useContext, useEffect, useRef, useState } from "react";
import { PAGES } from "utils/constants";
import { PageContext } from "utils/PageContext";
import { compScoreFinalCalculation, titleVerbTense } from "utils/scoringUtils";
import { UserContext } from "utils/UserContext";

function SongScoring() {
  const {
    albumTracks,
    setConnectionScore,
    selectedScoreType,
    currentRatings,
  } = useContext(UserContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const { setPage } = useContext(PageContext);

  const mainTheme = useTheme();

  const mobile = useMediaQuery(mainTheme.breakpoints.down("sm"));

  const ratingsLength = Object.keys(currentRatings).length

  const isPageComplete = albumTracks.length === ratingsLength

  const audioRef = useRef(null);

  const [audioStatus, setAudioStatus] = useState({
    isReady: false,
    isPlaying: false,
  });

  const handlePrevPage = () => {
    setAudioStatus((prev) => ({
      ...prev,
      isReady: false,
      isPlaying: false,
    }));
    audioRef.current.pause();
    setPage(PAGES.SCORETYPE);
  };

  const handleNextPage = () => {
    if (isPageComplete) {
      audioRef.current.pause();
      compScoreFinalCalculation(
        currentRatings,
        setConnectionScore
      );
      setPage(PAGES.FAVORITE);
    }
  };

  return (
    <>
      <Header />
      <CenteredColumnGrid
        container
        sx={{
          paddingTop: "calc(2rem + 100px)",
          textAlign: "center",
        }}
      >
        <Grid item>
          <Typography
            component="h1"
            variant={mobile ? "mobileDirections" : "directions"}
            sx={{
              padding: "0 1rem",
            }}
          >
            Select how each song {titleVerbTense(selectedScoreType)} you feel.
          </Typography>

          <Stack
            direction="row"
            spacing={1}
            flexWrap="wrap"
            justifyContent="center"
            sx={{
              gap: "0.35rem",
            }}
          >
            <RatingButtonsGuide />
          </Stack>
        </Grid>
      </CenteredColumnGrid>
      <MainContainer component="main">
        {/* CenteredColumnGrid causes SongScoringList to not be as responsive so regular grid is here instead */}
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item sm={8}>
            <SongScoringList
              audioRef={audioRef}
              audioStatus={audioStatus}
              setAudioStatus={setAudioStatus}
            />
          </Grid>
        </Grid>
      </MainContainer>
      <PageArrows
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
        isPageComplete={isPageComplete}
      />
    </>
  );
}

export default SongScoring;
